import { render } from "./Signatures_template.vue?vue&type=template&id=288f6fc8&scoped=true"
import script from "./Signatures_template.vue?vue&type=script&lang=js"
export * from "./Signatures_template.vue?vue&type=script&lang=js"

import "./Signatures_template.vue?vue&type=style&index=0&id=288f6fc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-288f6fc8"]])

export default __exports__